/**
 * @author Fernando Ruano
 * @file constants.js
 * @description Glucometry Constants
 */

// Generic actions
export const GET_ALL_GLUCOMETRIES = 'Glucometry/GET_ALL_GLUCOMETRIES';
export const GET_ALL_GLUCOMETRY_TIMES = 'Glucometry/GET_ALL_GLUCOMETRY_TIMES';
export const GET_GLUCOMETRY_BY_ID = 'Glucometry/GET_GLUCOMETRY_BY_ID';
export const GET_GLUCOMETRY_BY_PATIENT_ID =
  'Glucometry/GET_GLUCOMETRY_BY_PATIENT_ID';
export const CREATE_GLUCOMETRY = 'Glucometry/CREATE_GLUCOMETRY';
export const UPDATE_GLUCOMETRY = 'Glucometry/UPDATE_GLUCOMETRY';
export const DELETE_GLUCOMETRY_BY_ID = 'Glucometry/DELETE_GLUCOMETRY_BY_ID';
